import {$http} from './utils/fetch.js';
//import {Base64} from 'js-base64';
import Cookies from 'js-cookie';
import MD5 from "js-md5";

var map = [[20, 19],[14, 15, 14, 3, 5],[19, 9, 7, 14]]
const auth_map = [1, 21, 20, 8, 15, 18, 9, 26, 1, 20, 9, 15, 14];
export function btfa(num) {
  return String.fromCharCode(64 + num).toLowerCase();
}
export function setAuthKey() {
    let auth_key = "";
    auth_map.forEach(item => {
        auth_key += btfa(item);
    })
    return auth_key;
}
//function isEmpty(value) {
//    if (value == undefined || value == null || value == "" || value == 0) {
//        return true;
//    } else {
//        return false;
//    }
//}

function isEndWith(path, endStr) {
    let diff = path.length - endStr.length;
    if (diff >= 0 && path.lastIndexOf(endStr) == diff) {
        return true;
    } else {
        return false;
    }
}

function logoutRedirect() {
    //return new Promise((resolve, reject) => {
    //    $http._request('/auth/logout', 'get').do(data => {
    //        resolve(data)
    //    })
    //})
}

function formatDate(date, fmt) {
    /**
     * 将日期格式化成指定格式的字符串
     * @param date 要格式化的日期，不传时默认当前时间，也可以是一个时间戳
     * @param fmt 目标字符串格式，支持的字符有：y,M,d,q,w,H,h,m,S，默认：yyyy-MM-dd HH:mm:ss
     * @returns 返回格式化后的日期字符串
     */
    if (!date) return '';
    date = date == undefined ? new Date() : new Date(date);
    date = typeof date == 'number' ? new Date(date) : date;
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
    var obj =
        {
            'y': date.getFullYear(), // 年份，注意必须用getFullYear
            'M': date.getMonth() + 1, // 月份，注意是从0-11
            'd': date.getDate(), // 日期
            'q': Math.floor((date.getMonth() + 3) / 3), // 季度
            'w': date.getDay(), // 星期，注意是0-6
            'H': date.getHours(), // 24小时制
            'h': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
            'm': date.getMinutes(), // 分钟
            's': date.getSeconds(), // 秒
            'S': date.getMilliseconds() // 毫秒
        };
    var week = ['天', '一', '二', '三', '四', '五', '六'];
    for (var i in obj) {
        fmt = fmt.replace(new RegExp(i + '+', 'g'), function (m) {
            var val = obj[i] + '';
            if (i == 'w') return (m.length > 2 ? '星期' : '周') + week[val];
            for (var j = 0, len = val.length; j < m.length - len; j++) val = '0' + val;
            return m.length == 1 ? val : val.substring(val.length - m.length);
        });
    }
    return fmt;
}

//数字转换成中文
function Chinese(input) {
    var numberValue = new String(Math.round(input * 100)); // 数字金额
    var chineseValue = ""; // 转换后的汉字金额
    var String1 = "零一二三四五六七八九"; // 汉字数字
    var String2 = "万千百十亿千百十万千百十个个个"; // 对应单位
    var len = numberValue.length; // numberValue 的字符串长度
    var Ch1; // 数字的汉语读法
    var Ch2; // 数字位的汉字读法
    var nZero = 0; // 用来计算连续的零值的个数
    var String3; // 指定位置的数值
    if (len > 15) {
        alert("超出计算范围");
        return "";
    }
    if (numberValue[0] == 'N') {
        chineseValue = "请输入二维码个数";
        return chineseValue;
    }
    if (numberValue == 0) {
        chineseValue = "零个";
        return chineseValue;
    }
    String2 = String2.substr(String2.length - len, len); // 取出对应位数的STRING2的值
    for (var i = 0; i < len; i++) {
        String3 = parseInt(numberValue.substr(i, 1), 10); // 取出需转换的某一位的值
        if (i != (len - 3) && i != (len - 7) && i != (len - 11) && i != (len - 15)) {
            if (String3 == 0) {
                Ch1 = "";
                Ch2 = "";
                nZero = nZero + 1;
            } else if (String3 != 0 && nZero != 0) {
                Ch1 = "零" + String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            } else {
                Ch1 = String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            }
        } else { // 该位是万亿，亿，万，元位等关键位
            if (String3 != 0 && nZero != 0) {
                Ch1 = "零" + String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            } else if (String3 != 0 && nZero == 0) {
                Ch1 = String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            } else if (String3 == 0 && nZero >= 3) {
                Ch1 = "";
                Ch2 = "";
                nZero = nZero + 1;
            } else {
                Ch1 = "";
                Ch2 = String2.substr(i, 1);
                nZero = nZero + 1;
            }
            if (i == (len - 11) || i == (len - 3)) { // 如果该位是亿位或元位，则必须写上
                Ch2 = String2.substr(i, 1);
            }
        }
        chineseValue = chineseValue + Ch1 + Ch2;
    }
    return chineseValue;
}

//保留两位小数
//number：要转换的数字
//_format：要保留几位小数；默认保留两位
//_zerFill:是否补零。默认补零
function accurateDecimal(number, _format, _zeroFill) {
    let format = _format ? _format : 2;
    let zeroFill = _zeroFill === false ? false : true;
    //判断非空
    if (!isEmpty(number)) {
        //正则匹配:正整数，负整数，正浮点数，负浮点数
        if (!/^\d+(\.\d+)?$|^-\d+(\.\d+)?$/.test(number))
            return number;
        let n = 1;
        for (let i = 0; i < format; i++) {
            n = n * 10;
        }

        //四舍五入
        number = Math.round(number * n) / n;
        let str = number.toString();

        //是否补零
        if (zeroFill) {
            let index;
            if (str.indexOf(".") == -1) {
                index = format;
                str += '.';
            } else {
                index = format - ((str.length - 1) - str.indexOf("."));
            }
            for (let i = 0; i < index; i++) {
                str += '0';
            }
        }
        return str;
    }
    return number;
};

//非空验证
function isEmpty(ObjVal) {
    if ((ObjVal == null || typeof (ObjVal) == "undefined") || (typeof (ObjVal) == "string" && ObjVal == "" && ObjVal != "undefined")) {
        return true;
    } else {
        return false;
    }
}

//复制
function clone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'shallowClone');
    }
    var targetObj = source.constructor === Array ? [] : {};
    for (var keys in source) {
        if (source.hasOwnProperty(keys)) {
            if (source[keys] && typeof source[keys] === 'object') {
                targetObj[keys] = source[keys].constructor === Array ? [] : {};
                targetObj[keys] = clone(source[keys]);
            } else {
                targetObj[keys] = source[keys];

            }
        }
    }
    return targetObj;
}

//function encode(name, value) {
//    var str = value.toString();
//    var result = Base64.encode(str);
//    Cookies.set(name, result);
//}
//
//function decode(name) {
//    var str = Cookies.get(name);
//    var result = Base64.decode(str);
//    var arr = result.split(',');
//    return arr;
//}

//获取当前时间，格式YYYY-MM-DD
function getNowFormatDate() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
}

//n天前时间计算
function getBeforeDate(n, currentdate) {
    var n = n;
    var d = new Date(currentdate);
    var year = d.getFullYear();
    var mon = d.getMonth() + 1;
    var day = d.getDate();
    if (day <= n) {
        if (mon > 1) {
            mon = mon - 1;
        } else {
            year = year - 1;
            mon = 12;
        }
    }
    d.setDate(d.getDate() - n);
    year = d.getFullYear();
    mon = d.getMonth() + 1;
    day = d.getDate();
    var beforeDate = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
    return beforeDate;
}

var currentDate = getNowFormatDate();
var currentDate_day = getNowFormatDate();
var beforeDate = getBeforeDate(6, currentDate);
currentDate_day = new Date(currentDate_day += ' 00:00:00');
currentDate = new Date(currentDate += ' 23:59:59');

beforeDate = new Date(beforeDate += ' 00:00:00');
var bfrDate = getBeforeDate(2, currentDate);
bfrDate = new Date(bfrDate += ' 00:00:00');

function getUrlKey(name, url) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
}

function getCookie(key) {
    let value = Cookies.get(key);
    if (value == undefined) {
        return "";
    }
    return value;
}

function setCookie(key, value) {
    return Cookies.set(key, value)
}

function removeCookie(key) {
    return Cookies.remove(key)
}

function is_wx() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}

/** *
 *
 * 获取请求的UUID，指定长度和进制,如
 * getUUID(8, 2) //"01001010" 8 character (base=2)
 * getUUID(8, 10) // "47473046" 8 character ID (base=10)
 * getUUID(8, 16) // "098F4D35"。 8 character ID (base=16)
 *
 */
export function getUUID(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = []
    var i
    radix = radix || chars.length
    if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
        var r
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16
                uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
            }
        }
    }
    return uuid.join('')
}

export function sn() {
    let t = Math.floor(new Date().getTime() / 1000);
    let n = getUUID(32, 16);
    let date = `${new Date().getFullYear()}${new Date().getMonth() + 1 < 10? '0'+(new Date().getMonth() + 1) : new Date().getMonth() + 1 }${new Date().getDate() < 10? '0'+new Date().getDate() : new Date().getDate() }`;
    let s = MD5(`${t}${n}${date}12#$${date}`).toUpperCase();
    let res = {}
    map.forEach((item, index) => {
        let key = '';
        item.forEach(ele => {
            key += btfa(ele);
        })
        if(index == 0) {
            res[key] = t;
        } else if(index == 1) {
            res[key] = n;
        } else {
            res[key] = s;
        }
    })
    return res;
}

export default {
    $http,
    getCookie, setCookie, removeCookie,
    logoutRedirect,
    formatDate,
    accurateDecimal,
    clone,
    Chinese,
    currentDate,
    currentDate_day,
    beforeDate,
    bfrDate,
    isEndWith,
    isEmpty,
    getUrlKey,
    is_wx,
    sn,
}
//encode,
//decode,


// WEBPACK FOOTER //
// ./src/other/tool.js